var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-data-table',{staticClass:"elevation-1",attrs:{"color":"blue lighten-4","item-key":"data","headers":_vm.headers,"items":_vm.usoSorted,"options":_vm.options,"loading":_vm.loading,"footer-props":{
      itemsPerPageOptions: [5, 10, 15, 50, 100]
    }},on:{"update:options":function($event){_vm.options=$event}},scopedSlots:_vm._u([{key:"item.data",fn:function(ref){
    var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("date")(item.data))+" ")]}},{key:"item.primoAccesso",fn:function(ref){
    var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("dateTime")(item.primoAccesso))+" ")]}},{key:"item.ultimoAccesso",fn:function(ref){
    var item = ref.item;
return [_vm._v(" "+_vm._s(_vm._f("dateTime")(item.ultimoAccesso))+" ")]}}],null,true),model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})}
var staticRenderFns = []

export { render, staticRenderFns }